import { Pipe, PipeTransform } from '@angular/core';
import { snakeCase } from 'lodash-es';

@Pipe({
  name: 'snakeCase',
  standalone: true,
})
export class SnakeCasePipe implements PipeTransform {
  /** Used to match words composed of alphanumeric characters. */
  private readonly wordRegex: RegExp = /(?:[A-Z]{0,1}[a-z]+)+?/g;

  public transform(value: string): string;
  public transform(value: null | undefined): null | undefined;
  public transform(value: string | null | undefined): string | null | undefined {
    if (typeof value === 'string') {
      return snakeCase(value);
    }
    return value;
  }
}
